/**
 * Phase 2 — My Library mock payload (future API shape).
 * Set MY_LIBRARY_MOCK_EMPTY to true to preview the empty vault state.
 */

export const MY_LIBRARY_MOCK_EMPTY = false;

/** @typedef {"owned" | "pending" | "locked"} LibraryItemStatus */

/**
 * @typedef {Object} OwnedNftComic
 * @property {string} assetSlug
 * @property {string} title
 * @property {string} editionName
 * @property {string} tierKey
 * @property {string} tokenId
 * @property {string} contractAddress
 * @property {string} nftCoverImage
 * @property {string} interiorStatus
 * @property {string} accessSummary
 * @property {string[]} benefits
 * @property {LibraryItemStatus} status
 */

/**
 * @typedef {Object} OwnedDigitalEdition
 * @property {string} assetSlug
 * @property {string} title
 * @property {"digital_comic" | "ebook"} type
 * @property {string} pricePaid
 * @property {string} coverImage
 * @property {string} format
 * @property {string} accessStatus
 * @property {string} description
 */

const POPULATED_NFT = [
  {
    assetSlug: "treydora-genesis-comic",
    title: "Treydora Genesis Comic",
    editionName: "Reader Access Edition",
    tierKey: "reader_access",
    tokenId: "4827",
    contractAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
    nftCoverImage: "04_library_featured_display.png",
    interiorStatus: "Ready in Treydora reader",
    accessSummary: "Comic Reader + Game Access",
    benefits: [
      "NFT cover art from metadata — often one combined front/back image (IPFS)",
      "Interior comic served through Treydora reader",
      "Treydora & Oshar access per edition tier",
    ],
    status: "owned",
  },
];

const POPULATED_DIGITAL = [
  {
    assetSlug: "digital-comic-copy",
    title: "Digital Comic Copy",
    type: "digital_comic",
    pricePaid: "$5.99",
    coverImage: "02_library_tomes_reader_background.png",
    format: "Digital · Treydora viewer",
    accessStatus: "Active",
    description: "No NFT required. Readable in the Treydora viewer.",
  },
  {
    assetSlug: "treydora-rise-of-koraxos",
    title: "Treydora: Rise of Koraxos",
    type: "ebook",
    pricePaid: "$9.99",
    coverImage: "00_library_page_master_mockup.png",
    format: "eBook · Novel",
    accessStatus: "Active",
    description: "The book that began the world of Treydora.",
  },
];

export const ownedNftComics = MY_LIBRARY_MOCK_EMPTY ? [] : POPULATED_NFT;

export const ownedDigitalEditions = MY_LIBRARY_MOCK_EMPTY ? [] : POPULATED_DIGITAL;

export const readerPreview = MY_LIBRARY_MOCK_EMPTY
  ? {
      assetSlug: "",
      nftCoverImage: "",
      interiorPreviewImage: "",
      storytellerImageFile: "",
      progress: "",
    }
  : {
      assetSlug: "treydora-genesis-comic",
      nftCoverImage: "04_library_featured_display.png",
      interiorPreviewImage: "02_library_tomes_reader_background.png",
      storytellerImageFile: "03_ai_storyteller_oracle.png",
      progress: "Issue 1 · Page 12 of 48",
    };

/** Hero stat chips + summary card sources */
export function getOwnershipSummary(ownedNft, ownedDigital) {
  const nftCount = ownedNft.length;
  const digitalCount = ownedDigital.length;
  const hasReader = nftCount > 0 || digitalCount > 0;
  return {
    nftComics: nftCount,
    digitalEditions: digitalCount,
    readingAccess: hasReader ? "Active" : "Locked",
    loreAccess: hasReader ? "Owner Mode Preview" : "Teaser Only",
  };
}

export const MY_LIBRARY_HERO_STATS = (nftCount, digitalCount, readingActive, loreLabel) => [
  { key: "nft", label: "NFT Comics Owned", value: String(nftCount) },
  { key: "digital", label: "Digital Books", value: String(digitalCount) },
  { key: "reader", label: "Comic Access", value: readingActive ? "Active" : "—" },
  { key: "lore", label: "Storyteller Mode", value: loreLabel },
];
